function toKebabCase(string) {
  return string
    .replace(/&/g, '')
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/[^a-zA-Z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '') 
    .toLowerCase();
}

function updateGroupAddress(group) {
    let groupParent = document.querySelector('#group-addresses');
    let groupId = '#' + toKebabCase(group);

    groupParent.style.display = "block";
    
    groupParent.querySelectorAll('div').forEach(div => {
        div.style.display = 'none';
    });

    let groupAddress = document.querySelector(groupId);
    groupAddress.style.display = 'block';
}

setTimeout(() => {
    const variantInputs = document.querySelectorAll('.variant-option__select');
    const variantInput = variantInputs[0];
    const groupInputs = document.querySelectorAll('.tpo_option-input');
    const groupInput = groupInputs[0];
    const groupAddresses = document.querySelector('#group-addresses');

    variantInput.addEventListener('change', event => {
        if (event.target.value == 'Local Delivery or Pickup') {
            groupAddresses.style.display = 'none';
        } else {
            groupAddresses.style.display = 'block';
        }
    })

    groupInput.addEventListener('blur', event => {
        setTimeout(() => {
            updateGroupAddress(event.target.value);
        }, 300);
    });

}, 2000);